import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages as OnboardingMessages } from '../../constants/Onboarding';
import * as Utils from '../../utils';

import './GenomeTile.scss';

const GenomeTile = props => {
  const classNames = Utils.Css.createBEM('GenomeTile', {
    isMobile: props.isMobileDevice,
  });

  return (
    <div className={classNames}>
      {
        <p className='GenomeTile__header'>
          <FormattedMessage {...props.tileHeader} />
        </p>
      }
      {Utils.Url.isValidImgUrl(props.image) && (
        // eslint-disable-next-line jsx-a11y/alt-text
        <img className='GenomeTile__image' src={props.image} />
      )}
      <p className='GenomeTile__body'>
        <FormattedMessage
          {...props.tileText}
          values={{
            musicGenomeProject: (
              <b>
                <FormattedMessage {...OnboardingMessages.musicGenomeProject} />
                <sup>&reg;</sup>
              </b>
            ),
          }}
        />
      </p>
    </div>
  );
};

GenomeTile.propTypes = {
  image: PropTypes.string.isRequired,
  tileHeader: PropTypes.object,
  tileText: PropTypes.object.isRequired,
  isResponsive: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
};

export default GenomeTile;
